import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 40,
		height: 40,
		rx: 20,
		fill: "black",
		fillOpacity: .05
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.9998 19.9998C22.0257 19.9998 23.6665 18.359 23.6665 16.3332C23.6665 14.3073 22.0257 12.6665 19.9998 12.6665C17.974 12.6665 16.3332 14.3073 16.3332 16.3332C16.3332 18.359 17.974 19.9998 19.9998 19.9998ZM19.9998 21.8332C17.5523 21.8332 12.6665 23.0615 12.6665 25.4998V27.3332H27.3332V25.4998C27.3332 23.0615 22.4473 21.8332 19.9998 21.8332Z",
		fill: "black",
		fillOpacity: .16
	})]
});
export default SvgAvatar;
